import '~/App.css'
import {
  Panel,
  Legend,
  BasemapSelector,
  IconMenu,
  OverlayPanel,
  LanguageSelect,
} from '~/components'
import Map from '~/Map'
import { StagingGate } from '~/staging'
import { useAppStore } from './hooks'
import './util/cogConfig'

import IntroModal from './components/IntroModal'

function App() {
  const { overlayPanelVisible, setIntroModalOpen, introModalOpen, dataset } = useAppStore()

  return (
    <StagingGate>
      <div className="App">
        <Map />

        <IntroModal isOpen={introModalOpen} setIsOpen={setIntroModalOpen} dataset={dataset} />
        <IconMenu />
        <div className="pointer-events-none fixed inset-y-0 left-0 z-30 flex w-full flex-col gap-4 px-4 py-4 sm:w-[338px] sm:py-8">
          <Panel />
        </div>
        <div className="pointer-events-none absolute bottom-3 left-4 z-50 flex flex-row items-end gap-2 [&>*]:pointer-events-auto">
          {overlayPanelVisible && <OverlayPanel />}
          <LanguageSelect />
        </div>
        <div className="absolute bottom-3 right-4 z-50 flex flex-col gap-2">
          <Legend />
          <BasemapSelector />
        </div>
      </div>
    </StagingGate>
  )
}

export default App
